__turbopack_context__.v({
  "a": "Footer-module-scss-module__5BPAWa__a",
  "col": "Footer-module-scss-module__5BPAWa__col",
  "copyRights": "Footer-module-scss-module__5BPAWa__copyRights",
  "divider": "Footer-module-scss-module__5BPAWa__divider",
  "fillWhite": "Footer-module-scss-module__5BPAWa__fillWhite",
  "footer": "Footer-module-scss-module__5BPAWa__footer",
  "footerBar": "Footer-module-scss-module__5BPAWa__footerBar",
  "footerHead": "Footer-module-scss-module__5BPAWa__footerHead",
  "footerList": "Footer-module-scss-module__5BPAWa__footerList",
  "footerPlaystoreIcon": "Footer-module-scss-module__5BPAWa__footerPlaystoreIcon",
  "getInTouch": "Footer-module-scss-module__5BPAWa__getInTouch",
  "hiring": "Footer-module-scss-module__5BPAWa__hiring",
  "link__highlighted": "Footer-module-scss-module__5BPAWa__link__highlighted",
  "logoFooter": "Footer-module-scss-module__5BPAWa__logoFooter",
  "madeInIndia": "Footer-module-scss-module__5BPAWa__madeInIndia",
  "mostSearchedLinkContainer": "Footer-module-scss-module__5BPAWa__mostSearchedLinkContainer",
  "payments": "Footer-module-scss-module__5BPAWa__payments",
  "row": "Footer-module-scss-module__5BPAWa__row",
  "seoContent": "Footer-module-scss-module__5BPAWa__seoContent",
  "socialIconContainer": "Footer-module-scss-module__5BPAWa__socialIconContainer",
  "socialIconWrapper": "Footer-module-scss-module__5BPAWa__socialIconWrapper",
  "textFoot": "Footer-module-scss-module__5BPAWa__textFoot",
  "topLinks": "Footer-module-scss-module__5BPAWa__topLinks",
  "trustContent": "Footer-module-scss-module__5BPAWa__trustContent",
});
